import { render, staticRenderFns } from "./u-user-items-text.vue?vue&type=template&id=7ec9de00&scoped=true&"
import script from "./u-user-items-text.vue?vue&type=script&lang=js&"
export * from "./u-user-items-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec9de00",
  null
  
)

export default component.exports